export default "__VITE_ASSET__e13a8fd3__"